export default class SortOptions {
  column: string;
  direction: string;

  constructor(column: string, direction: string) {
    this.column = column;
    this.direction = direction;
  }
}



// WEBPACK FOOTER //
// ./src/models/content-wrapper/sort-options.ts